import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';

import {MeteringRecord} from '../types';
import {moduleConfig} from '../config';

// MeteringRecord has no single `id`; the leaf breadcrumb shows meteringRecordId
// (the deterministic identity hash) as the human-meaningful label.
export const EditPageNavigation = ({component}: { component: MeteringRecord }) => {

    const breadcrumbs = [
        {title: 'Home', href: '/dashboard'},
        {title: `${moduleConfig.titles.plural}`, href: moduleConfig.basePath},
        {title: component.meteringRecordId},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
